import PageHero from "../components/sections/PageHero";

const points = [
  "This website is intended only for general information about Lex Polaris, Advocates & Solicitors and is not an advertisement or solicitation.",
  "By accessing this website, you confirm that you are doing so voluntarily, of your own accord, and not as a result of any solicitation, advertisement or invitation.",
  "The information available on this website does not constitute legal advice. It should not be acted upon without seeking professional legal advice based on the specific facts and circumstances of your matter.",
  "Submission of any enquiry form, email or communication through this website does not create a lawyer-client relationship unless formally accepted by Lex Polaris, Advocates & Solicitors in writing.",
  "Communication through this website is not a substitute for a confidential consultation with a qualified advocate. Sensitive or confidential information should not be transmitted through this website.",
  "Lex Polaris, Advocates & Solicitors disclaims any liability for actions, decisions, loss or harm arising from reliance on information available through this website.",
  "This website may include references to general legal subjects. Such references are illustrative only and do not represent specific legal opinion on any matter.",
  "By continuing to use this website, you acknowledge and accept the terms of this disclaimer in full.",
];

export default function DisclaimerPage() {
  return (
    <>
      <PageHero
        eyebrow="Legal"
        title="Disclaimer"
        subtitle="Important information about the use of this website, in compliance with the rules of the Bar Council of India."
        breadcrumbs={[{ label: "Home", to: "/" }, { label: "Disclaimer" }]}
      />
      <section className="bg-ivory section-y" data-testid="disclaimer-page">
        <div className="container-px max-w-3xl mx-auto">
          <div className="overline mb-5">Bar Council of India Compliance</div>
          <h2 className="h-display text-3xl md:text-4xl text-navy mb-8">
            Disclaimer &amp; Confirmation
          </h2>
          <p className="body-lg text-charcoal/80 mb-10">
            As per the rules of the Bar Council of India, Lex Polaris, Advocates &amp; Solicitors is not
            permitted to advertise or solicit work through this website. The information made available is for
            general informational purposes only.
          </p>
          <ol className="space-y-6">
            {points.map((p, i) => (
              <li
                key={i}
                data-testid={`disclaimer-point-${i}`}
                className="flex items-start gap-5 border-b border-soft-grey pb-6"
              >
                <span className="font-serif text-gold text-sm pt-1 w-8 flex-shrink-0">
                  {String(i + 1).padStart(2, "0")}
                </span>
                <p className="body-lg text-charcoal/80">{p}</p>
              </li>
            ))}
          </ol>
          <p className="text-xs tracking-[0.22em] uppercase text-charcoal/55 mt-12 pt-8 border-t border-soft-grey">
            Last updated: {new Date().toLocaleDateString("en-IN", { year: "numeric", month: "long" })}
          </p>
        </div>
      </section>
    </>
  );
}
